import React, { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API_URL;

const EyeIcon = () => (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor" aria-hidden="true">
        <path d="M12 5c-5.5 0-9.5 4.5-10.5 6 .9 1.5 5 6 10.5 6s9.5-4.5 10.5-6C21.5 9.5 17.5 5 12 5zm0 10a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
    </svg>
);

const Blog = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`${API}/api/edolutions/blog`)
            .then(r => setPosts(r.data?.data?.data || r.data?.data || []))
            .catch(() => setPosts([]))
            .finally(() => setLoading(false));
    }, []);

    return (
        <section className="py-20 bg-gray-50 text-center">
            <h2 className="text-5xl font-bold text-gray-800 mb-8">Featured Articles</h2>
            <p className="max-w-2xl mx-auto text-center text-gray-600 mb-12">
                Insights, tips, and stories from the Cabil community — helping students,
                professionals, and families grow together.
            </p>

            {loading ? (
                <p className="text-gray-400">Loading articles...</p>
            ) : posts.length === 0 ? (
                <div className="max-w-md mx-auto py-12">
                    <div className="text-5xl mb-4">📝</div>
                    <p className="text-gray-500 font-medium">No articles published yet. Check back soon!</p>
                </div>
            ) : (
                <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto px-4">
                    {posts.map((a) => (
                        <article key={a.id}
                            className="bg-white rounded-2xl shadow-[0_12px_40px_rgba(16,24,40,0.08)] hover:shadow-[0_16px_48px_rgba(16,24,40,0.12)] transition-shadow duration-200 overflow-hidden text-left">
                            <div className="p-4">
                                <div className="h-40 md:h-44 w-full rounded-xl overflow-hidden bg-gradient-to-br from-orange-100 to-orange-200 flex items-center justify-center">
                                    {a.image ? (
                                        <img src={a.image} alt={a.title} className="w-full h-full object-cover" loading="lazy" />
                                    ) : (
                                        <span className="text-5xl">📄</span>
                                    )}
                                </div>
                            </div>
                            <div className="px-5 pb-5">
                                {a.category && (
                                    <span className="text-[10px] font-bold text-orange-600 bg-orange-50 px-2 py-0.5 rounded-full uppercase">
                                        {a.category}
                                    </span>
                                )}
                                <h3 className="text-base md:text-lg font-semibold text-slate-800 mt-2 line-clamp-2">
                                    {a.title}
                                </h3>
                                <div className="mt-2 flex items-center gap-2">
                                    <div className="w-6 h-6 rounded-full bg-orange-200 flex items-center justify-center text-xs font-bold text-orange-700">
                                        {(a.author_name || "C")[0]}
                                    </div>
                                    <span className="text-sm font-medium text-slate-600">{a.author_name || "Cabil Team"}</span>
                                    <span className="text-xs text-slate-400">· {new Date(a.created_at).toLocaleDateString()}</span>
                                </div>
                                {a.excerpt && <p className="mt-3 text-sm text-slate-600 line-clamp-2">{a.excerpt}</p>}
                                <div className="mt-4 flex items-center justify-between">
                                    <a href={`/blog/${a.slug}`}
                                        className="text-xs font-medium text-orange-500 hover:text-orange-700 underline underline-offset-4">
                                        Read more
                                    </a>
                                    <div className="flex items-center gap-1.5 text-xs text-orange-500">
                                        <EyeIcon />
                                        <span className="text-slate-400">{a.views || 0}</span>
                                    </div>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            )}
        </section>
    );
};

export default Blog;
